// extracted by css-extract-rspack-plugin
export default {"warningOverride":"ReviewRequestBanner-module__warningOverride__vCzi3"};